export default __webpack_public_path__ + "static/media/customer.af4187dd.svg";